module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.headerinfo.city) + " - " + _vm._s(_vm.headerinfo.season)), _c('span', [_vm._v(_vm._s(_vm.headerinfo.city) + " - " + _vm._s(_vm.headerinfo.season))])]), _vm._v(" "), (_vm.time) ? _c('timer', {
    attrs: {
      "time": _vm.time,
      "isActive": _vm.isActive
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7bcc5158!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Headertitle.vue
// module id = 181
// module chunks = 1